import builtInSelectors from './selectors';
import customMetricsSelectors from './CustomMetrics/selectors'
import { connect } from 'react-redux';
import { selectors as authSelectors, selectors as lifecycleSelectors } from '../../lifecycle/auth';
import { EventProps, ExternalValueProps, Props, BuiltInDashboard, LoadProps, OnViewProps } from './BuiltInDashboard'
import { AppState, Dispatch } from '../../types';
import { DetailedResource, Resource } from '../../common/resource/model'
import { Toast } from '../Toasts/model'
import { API, Environment } from '../../remote-api/models'
import { Profile } from '../../remote-api/CoreServicesRemoteApi'
import { TimeRange } from '@mulesoft/monitoring-center-components/lib/components/BuiltInDashboards/PreBuilt'
import { selectDashboardTypes } from '../ResourceSelector/actions';
import { addToast } from '../Toasts/actions'
import { selectEnvironmentAndFetchAllResources, selectResourceAndFetchVersions } from '../../common/selector/actions'
import { builtInOrigin } from './model'
import { selectVersion } from '../../common/version/actions'
import { notifyIframeError } from '../Iframe/actions'
import { AutoRefreshFrequency } from '@mulesoft/monitoring-center-components/lib/components/Toolbar/AutoRefresh/model'

import {
  autoRefreshChange,
  changeBuiltInHiddenDetail,
  dispatchViewedBuiltIn,
  loadBuiltInDashboards,
  mainSelectorOpen, manageAPI, manageApplication,
  rangeChange, configureLogPoints,
  saveAs,
  savedAsCustomDashboard, viewLogs,
  viewBuiltInDashboards, manageTarget
} from './actions'
import { ResourceType as ComponentsResourceType, ResourceType } from '@mulesoft/monitoring-center-components/lib/models/resource'
import { fetchFeaturesCompatibility } from '../../common/compatibility/actions';
import { fetchLabels } from '../../common/labels/actions';
import FeatureFlagService from '../../services/FeatureFlagService';
import FeatureFlags from '../../types/featureflags';

const mapProps = (state: AppState, ownProps: ExternalValueProps): Props => ({
  ...ownProps,
  labels: state.monitoring.labels.resources,
  profile: authSelectors.getProfile(state).getOrUndefined() as Profile | undefined,
  hasEditRole: authSelectors.hasEditRole(state),
  orgDomain: state.monitoring.auth.profile ? state.monitoring.auth.profile.organizationDomain : '',
  organizationId: lifecycleSelectors.getOrganizationId(state),
  dashboardType: ownProps.dashboardType || builtInSelectors.getDashboardType(),
  environmentSelector: builtInSelectors.environmentSelector.getAll(state),
  resourceSelector: builtInSelectors.resourceSelector.getAll(state),
  versionSelector: builtInSelectors.versionSelector.getAll(state),
  isTitanium: authSelectors.isMonitoringCenterPremium(state),
  isLogPointsCompatible: builtInSelectors.isLogPointsCompatible(state),
  toasts: state.monitoring.toasts.toastList,
  metrics: customMetricsSelectors.metrics(state),
  details: builtInSelectors.getResourceDetails(state),
  range: builtInSelectors.range(state),
  autoRefresh: builtInSelectors.autoRefresh(state),
  featuresCompatibility: state.monitoring.featuresCompatibility.resources,
})

const mapDispatch = (dispatch: Dispatch): EventProps => ({
  environmentSelected: (environmentId: string, environments?: Environment[]) =>
    dispatch(selectEnvironmentAndFetchAllResources({origin: builtInOrigin, withMetrics: true}, environmentId, environments)),
  resourceSelected: (resourceId: string, resourceType: ResourceType, resources?: Resource[]) =>
    dispatch(selectResourceAndFetchVersions({origin: builtInOrigin, resourceType}, resourceId, resources)),
  versionSelected: (versionId: string, versions: API[]) =>
    dispatch(selectVersion({origin: builtInOrigin}, versions, versionId)),
  mainSelectorOpen: (environment?: {selected: Environment, list: Environment[]},
                     resource?: {selected: Resource, list: Resource[]},
                     version?: {selected: API, list: API[]}) =>
    dispatch(mainSelectorOpen(environment, resource, version)),
  view: (props: OnViewProps) => dispatch(viewBuiltInDashboards(props)),
  load: (props: LoadProps & {componentsResourceType: ComponentsResourceType}) => dispatch(loadBuiltInDashboards(props)),
  rangeChange: (range: TimeRange) => dispatch(rangeChange(range)),
  saveDashboard: (dashboardType: string) => dispatch(selectDashboardTypes(dashboardType)),
  addToast: (toast: Toast) => dispatch(addToast(toast)),
  fetchLabels: () => dispatch(fetchLabels('monitoring')),
  viewLogs: (logSearchLink: string) => dispatch(viewLogs(logSearchLink)),
  manageAPI: (orgDomain: string, organizationId: string, environmentId: string, resource?: DetailedResource) =>
    dispatch(manageAPI(orgDomain, organizationId, environmentId, resource)),
  manageApplication: (orgDomain: string, organizationId: string, environmentId: string, resource?: DetailedResource) =>
    dispatch(manageApplication(orgDomain, organizationId, environmentId, resource)),
  manageTarget: (orgDomain: string, organizationId: string, environmentId: string, resource?: DetailedResource) =>
    dispatch(manageTarget(orgDomain, organizationId, environmentId, resource)),
  configureLogPoints: (environmentId: string, resource: Resource, versionId?: string) =>
    dispatch(configureLogPoints(environmentId, resource, versionId)),
  saveAs: (dashboardType: string) => dispatch(saveAs(dashboardType)),
  savedAsCustomDashboard: (dashboardType: string) => dispatch(savedAsCustomDashboard(dashboardType)),
  notifyIframeError: (error: any) => dispatch(notifyIframeError(error)),
  onDetailHide: (isDetailHidden: boolean) => dispatch(changeBuiltInHiddenDetail(isDetailHidden)),
  onAutoRefreshToggle: (checked: boolean, frequency: AutoRefreshFrequency) => dispatch(autoRefreshChange(checked, frequency)),
  dispatchViewedBuiltIn: (resource: Resource, versionId?: string) => dispatch(dispatchViewedBuiltIn(resource, versionId)),
  viewCompatibility: (organizationId: string, environmentId: string, resourceType: string, resId: string) =>
    dispatch(fetchFeaturesCompatibility(organizationId, environmentId, resourceType, resId, 'monitoring')),
})

export default connect(mapProps, mapDispatch)(BuiltInDashboard)
